<template>
  <div class="groups" v-loading="isLoading">
    <div class="group-item" v-for="(group, index) in groups" :key="index">
      <div class="info">
        <div class="name">{{ group.name }}</div>
        <div class="desc" v-if="group.remark">备注: {{ group.remark }}</div>
      </div>
      <div class="opts">
        <div class="btn">
          <icon iconName="iconshezhi" />
          <router-link :to="`/groups/${group.code}`" tag="span">
            <span class="text">设置</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {components} from '@x-tech/fe-puma-lib';
const {Icon} = components;
import {getAllGroups} from '../../apis/index';

export default {
  name: 'Groups',
  components: {
    Icon
  },
  data() {
    return {
      isLoading: false,
      groups: []
    };
  },
  computed: {},
  async mounted() {
    this.isLoading = true;

    let res = await getAllGroups();

    this.groups = res;
    this.isLoading = false;
  }
};
</script>

<style lang="scss" scoped>
.groups {
  display: flex;
  width: 100%;
  height: 100%;
  flex-flow: row wrap;
  padding: 8px;
  box-sizing: border-box;
}
.group-item {
  $margin: 4px;
  width: auto;
  overflow: auto;
  height: 160px;
  border: 1px solid rgba(235, 238, 245, 1);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: $margin;
  flex: 0 1 calc(25% - 8px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .info {
    flex: 1;
    padding: 20px;
    box-sizing: border-box;
    .name {
      font-size: 18px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .desc {
      margin-top: 16px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
  }
  .opts {
    min-height: 30px;
    background: rgba(245, 247, 250, 1);
    border: 1px solid rgba(235, 238, 245, 1);
    align-items: center;
    display: flex;
    box-sizing: border-box;
    padding: 0 12px;
  }
  .btn {
    display: inline-block;
    font-size: 14px;
    color: #666;
    cursor: pointer;

    ::v-deep .iconfont {
      font-size: 14px;
    }

    .text {
      margin-left: 9px;
      color: #666;
    }
  }
}
</style>
